const SeverityBadge = ({ text }) => (
  <span className="px-2 py-1 rounded-md text-xs font-semibold bg-[rgba(2,32,71,0.08)] text-gray-800">
    {text}
  </span>
)

export default SeverityBadge